// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2urOC","text":"SelectPayment_text__1dZ6o","title":"SelectPayment_title__JaUpV","btn":"SelectPayment_btn__2-tMz"};